import ReactDOM from "react-dom";
import Utility from "../../utilities/Utility";
import NewFolderEmbed from "./NewFolderEmbed";
import BaseDialog from "./BaseDialog";
import FolderTree from "./FolderTree";

export default class NewFolderDialog extends BaseDialog {
    /**
     * Dialog to add a new element to application, with search ability
     * @module NewFolderDialog
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            query: "",
            tab: this.props.type
        };
        this.itemWidth = 0;
        this.dynamicWidth = 45;
        this.toggleHandle = this.handleToggle.bind(this);
        this.addHandle = this.handleAdd.bind(this);
        this.selected = {};
        this.coOrdinates = this.props.event;
        this.commonModules = [];
        this.changeProps = this.changeProps.bind(this);
        
    }

    changeProps(type) {

        this.setState({tab: type});

    }
    componentDidMount() {
        
        super.componentDidMount();
        document.addEventListener("ev-dialog-toggle", this.toggleHandle);
        document.addEventListener("ev-dialog-add", this.addHandle);
        this.getDomSelf().find(".new_" + this.props.type).tab('show');
        this.getDomSelf().find(".nav-button a").on("click", () => {
            this.setSelected("");
        });
        this.itemWidth = parseInt(this.getDomSelf().find(".element-item").width()) / 100 * this.getDomSelf().outerWidth();
        
    }
    unregister() {
        document.removeEventListener("ev-dialog-toggle", this.toggleHandle);
        document.removeEventListener("ev-dialog-add", this.addHandle);
    }

    /**
     * Update and filter dialog
     * @param {string} query
     */
    doFilter(query) {
        this.setState({ query: query });
    }
    /**
     * Set currently selected template item
     * @param {Object} item
     * @param {string} type
     */
    setSelected(item, type) {
        if (item) {
            this.selected = {
                item: item,
                type: type
            }
        } else {
            $(".element-item").removeClass("selected");
        }
    }

    /**
     * Render element group
     * @param {string} type
     * @returns {Array<XML>}
     */
    renderCommonElements(type) {
        
        const items = [];
        const idname = type+"container";
        
        items.push({
            id: "__folder",
            name: "folder",
            type: type,
            props: {
                iconClass: "folder",
                config: {
                    description: "Add Folder For " + window.l.popup[type]
                }
            }
        });
        var elements = [];
        elements.push(<FolderTree key={type} context={this} type={type}
        items={items} dynamicWidth={this.dynamicWidth} idname={idname} />);
        
        return elements;
    }
    /**
     * Update item display width; tighter columns for bigger dialog to show more stuff in a single row
     * @param event
     */
    handleToggle(event) {
        if (this.itemWidth) {
            this.dynamicWidth = this.itemWidth / this.getDomSelf().outerWidth() * 100;
            this.getDomSelf().find(".element-item").css("width", this.dynamicWidth + "%");
        }
    }
    /**
     * Handle add to application event
     * @param event
     */
    handleAdd(type) {
        if (type) {
                w2popup.message({
                    width: 500,
                    height: 220,
                    html: '<div class="blank_container"></div>',
                    onOpen: () => {
                        this.intervalHandle = setInterval(() => {
                            if($(".blank_container")){
                                clearInterval(this.intervalHandle);

                                $(".w2ui-message").css("transform", "");
                                ReactDOM.render(
                                    <NewFolderEmbed 
                                        key={Utility.uuid4()} 
                                        addFunc={NewFolderDialog.addElement} 
                                        changeProps={this.changeProps} 
                                        type={type} 
                                        coOrdinates={this.coOrdinates}/>, $(".blank_container").get(0)
                                );
                            }
                        }, 10);
                    }
                });
                return;
            
        } else {
            window.apm.popupMessage(window.l.popup.select_one_before_add);
        }
    }
   
    /**
     * Add to application model
     * @param {jQuery} treeDom Treeview reference the element will be added to
     * @param {Object} item
     * @param {boolean} useSameId use the same ID as the original if set to true
     */
    static addElement(treeDom, item, useSameId = false, itemId = null, coOrdinates=null) {
        // new node
        if (!item.node) {
            const addNode = (treeDom, parent, node, lockName) => {
                
                if (useSameId) node.id = item.id;
            
                window.apm.addNode(node);
                  
            };
            
            var lockName = false;
            
            const newNode = JSON.parse(JSON.stringify(item));
            newNode.id = Utility.uuid4();
            newNode.props.createdTime = window.apm.timestamp
            newNode.props.timeAddedToFlow = window.apm.timestamp;
            newNode.name = window.apm.getEligibleTreeName(treeDom, item.name, item.type, item.props.folderType);
                if (!treeDom.jstree().get_node(newNode.props.folderType)) {
                    // add type name folder if not exist
                    treeDom.jstree().create_node(newNode.props.folderType+"s", {
                        "id": newNode.name,
                        "text": newNode.name,
                        "icon": "/lib/feather/folder.svg",
                        "type": newNode.props.folderType+"s",
                        "state": { "opened": true },
                        "children": []
                    }, "last", (new_node) => {
                        addNode(treeDom, newNode.props.folderType+"s", newNode, lockName)
                    });
                } else {
                   addNode(treeDom, newNode.props.nodeTypeName, newNode, lockName);
                }
            
            return;
        }
        
    }

    /**
     * React render
     * @returns {XML}
     */
    render() { 
        
        return (
            <div className="container-fluid element-dialog">
                <div className={"context_menu"}></div>
                <div className={"row"}>
                    <div className="tab-title col-md-12">
                        <ul className="nav nav-tabs">
                            
                            <li className="nav-button" onClick={()=>this.changeProps("module")}>
                                <a data-toggle="tab" href="#new_module" className="new_module">{window.l.popup.module}</a>
                            </li>
                            <li><div className="break" /></li>
                            <li className="nav-button" onClick={()=>this.handleAdd(this.state.tab)} id={"addfolder"} key={"addfolder"}>
                        
                                <a className={"jstree-anchor"} href={"#"} id={"uncategorized_anchor"} name={"uncategorized"}>
                                {" + New "+this.state.tab+" Folder"}</a>
                            </li>
                            
                            <li>
                            </li>
                        </ul>
                        
                    </div>
                    <div className="col-md-12">
                        <hr />
                    </div>
                    <div className="tab-content col-md-12">
                    <div id="new_folder" className="tab-pane fade">
                        </div>
                        <div id="new_module" className="tab-pane fade">
                            {this.renderCommonElements("module")}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}